import React, { FC, useState } from "react"

type Props = {
  toggled: boolean

  onClick: any
}

export const Toggle: FC<Props> = (props) => {
  const [isToggled, toggle] = useState(props.toggled)

  const callback = () => {
    toggle(!isToggled)
    props.onClick(!isToggled)
  }

  return (
    <label className="t-label">
      <input
        className="t-input"
        type="checkbox"
        defaultChecked={isToggled}
        onClick={callback}
      />
      <span className="t-span" />
    </label>
  )
}
